import { RelatedProperty } from '../../../../types';

export type FetchRelatedPropertiesRequest = {
  propertyId: number;
  email: string;
  type: 'terrains' | 'projects';
  limit?: number;
};

export type FetchRelatedPropertiesResponse = Array<RelatedProperty>;

export default async function fetchRelatedProperties(
  request: FetchRelatedPropertiesRequest
): Promise<FetchRelatedPropertiesResponse> {
  const response = await fetch(
    `/api/leads/related/${request.type}/${request.propertyId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: request.email,
        limit: request.limit || 2
      })
    }
  );

  return response.json();
}
